import { AnyAction, Dispatch } from 'redux';
import { VOLUME_LEEWAY_TO_DISABLE_MUSIC } from '../../../constants/app-constants';
import AnalyticsEventUtil from '../../../infra/analytics/analytics-event-util';
import { GlobalAction } from '../../../store/reducers/global.reducer';
import { disableMusic, enableMusic, selectIsMusicEnabled, setSoundtrackVolume } from '../../../store/selectors/global.selector';
import { AppState } from '../../../store/store';
import { ThunkResult } from '../shared/ThunkResult';

export const setSoundtrackVolumeFromVolumeSlider = (volume?: number): ThunkResult<void> => {
  return (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    dispatch({ type: 'SET_USER_HAS_INTERACTED', payload: true } as GlobalAction);
    if (volume) {
      dispatch(setSoundtrackVolume(volume));
      AnalyticsEventUtil.getInstance().setSoundtrackVolume(volume);

      checkIfShouldTurnMusicOnOrOff(volume, selectIsMusicEnabled(getState()), dispatch);
    }
  };
};

const checkIfShouldTurnMusicOnOrOff = (volume: number, musicOn: boolean, dispatch: Dispatch<AnyAction>) => {
  if (musicOn === false && volume > VOLUME_LEEWAY_TO_DISABLE_MUSIC) {
    dispatch(enableMusic());
  } else if (musicOn === true && volume <= VOLUME_LEEWAY_TO_DISABLE_MUSIC) {
    dispatch(disableMusic());
  }
};
